/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { AdEditFields, assetSuggestionType } from '../constants';

// used for audience campaign non multimedia ad
export const getTextSuggestionAdoption = (textSuggestions, saveAdParams) => {
  const finalUrl = _.first(saveAdParams.FinalUrls);
  const autoCompleteSuggestions = _.get(textSuggestions, ['autoCompleteSuggestions', finalUrl], []);
  const creationSuggestions = _.get(textSuggestions, ['creationSuggestions', finalUrl], []);
  const businessNameSuggestions = _.get(textSuggestions, ['businessNameSuggestions', finalUrl], []);

  const suggestionMatch = (suggestion, assetType, testValue) =>
    suggestion.AssetType === assetType && suggestion.Text === testValue;

  return Object.keys(AdEditFields).reduce((textSuggestionAdoption, field) => {
    textSuggestionAdoption[field] = {
      value: saveAdParams[field],
    };
    const suggestionMatchForField =
      _.partial(suggestionMatch, _, assetSuggestionType[field], saveAdParams[field]);

    if (field === AdEditFields.BusinessName) {
      textSuggestionAdoption[field].isSuggestionAdopted =
        businessNameSuggestions.some(suggestionMatchForField);
    } else {
      textSuggestionAdoption[field].isSuggestionAdopted =
        autoCompleteSuggestions.some(suggestionMatchForField) ||
        creationSuggestions.some(suggestionMatchForField);
    }
    return textSuggestionAdoption;
  }, {});
};
